import { Link } from 'react-router';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_data.gif';
import ItemUtil, { type ItemData } from '../../lib/ItemUtil';
import ListBase, { type ListBaseProps } from '../lib/ListBase';
import DataUtil from './DataUtil';

class DataList extends ListBase {
    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Data';
        this.icon = iconFile;
    }

    // OpenNeuro extensions: the preview image, when there is one, stands in for the icon.
    renderIcon() {
        const { lang } = this.props;
        const item = this.props.item as ItemData;
        const preview = item.file.filter((value) => value.file_type_name === 'preview').pop();
        if (typeof preview === 'undefined') {
            return super.renderIcon();
        }
        const alt = preview.caption !== '' ? Functions.mlang(preview.caption, lang) : this.label;
        return <img src={ItemUtil.getPreviewFileUrl(preview)} alt={alt} />;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemData;
        const authors = item.experimenter.map((author) => Functions.mlang(author, lang)).join(', ');
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link>
                <br />
                <DataUtil.DataType lang={lang} type={item.data_type} />
                <br />
                {authors}
            </>
        );
    }
}

export default DataList;
